export class RoleResponseEntity {
  createdAt?: string;
  updatedAt?: string;
  name?: string;
  code?: string;
  type?: number;
  status?: number;
  note?: string;
  order?: string;
  maximum?: string;
  level?: number;

  constructor(data?: Partial<RoleResponseEntity>) {
    this.createdAt = data?.createdAt;
    this.updatedAt = data?.updatedAt;
    this.name = data?.name;
    this.code = data?.code;
    this.type = data?.type;
    this.status = data?.status;
    this.note = data?.note;
    this.order = data?.order;
    this.maximum = data?.maximum;
    this.level = data?.level;
  }
}
